export default __webpack_public_path__ + "static/valCitat-e6c048905735b37bfec32653b0104527.png";